import { action } from 'mobx'
import { Observer, observer } from 'mobx-react-lite'
import type { FilterProps } from '@/infra/type-utils'
import {
  NumericInput,
  type NumericInputProps,
} from '@/components/inputs/NumericInput'
import {
  type ContainerProps,
  FormFieldContainer,
} from '@/components/FormContainer'

/**
 * Form field container for a {@link NumericInput}.
 */
export const NumericInputContainer = observer(function NumericInputContainer<
  M extends object,
  K extends keyof FilterProps<M, number>,
>({
  name,
  model,
  label,
  sublabel,
  help,
  field,
  error,
  ...rest
}: ContainerProps<
  M,
  number,
  K,
  Omit<NumericInputProps, 'value' | 'onChange'>
>) {
  return (
    <FormFieldContainer
      name={name}
      model={model}
      label={label}
      sublabel={sublabel}
      help={help}
      field={field}
      error={error}
      render={(controlProps) => (
        // Using `Observer` here makes it so only the `NumericInput`
        // re-renders when the value changes.
        <Observer>
          {() => (
            <NumericInput
              value={model[field] as number}
              mode="draft"
              onChange={action(`change ${field}`, (value: number | null) => {
                model[field] = (value ?? 0) as M[K]
              })}
              name={controlProps.name}
              {...rest}
            />
          )}
        </Observer>
      )}
    />
  )
})
